import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useNotifications } from '@/providers/NotificationsProvider';
import { cn } from '@/lib/cn';

interface Props {
  to: string;
  className?: string;
}

/**
 * Top-bar notification icon with a live unread-count badge. Clicking it
 * navigates to the inbox (path differs per role).
 */
export function NotificationBell({ to, className }: Props) {
  const { unreadCount } = useNotifications();

  return (
    <Link
      to={to}
      className={cn(
        'relative inline-flex items-center justify-center rounded-lg p-2 text-ink-muted hover:bg-muted hover:text-ink transition',
        className,
      )}
      aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications'}
      title={unreadCount > 0 ? `${unreadCount} unread` : 'Notifications'}
    >
      <Bell className="h-4 w-4" />
      {unreadCount > 0 && (
        <span
          aria-hidden="true"
          className={cn(
            'absolute -top-0.5 -right-0.5 inline-flex min-w-[18px] h-[18px] items-center justify-center rounded-full px-1',
            'bg-danger text-white text-[10px] font-bold tabular-nums',
            'ring-2 ring-surface',
          )}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Link>
  );
}
